// extracted by mini-css-extract-plugin
export default {"link":"BaseApp__link--po8mp","loading-shimmer":"BaseApp__loading-shimmer--SQEaR","loadingShimmer":"BaseApp__loading-shimmer--SQEaR"};